






















































































































































interface SidebarMenu {
  to: {
    name: string;
  };
  title: string;
  icon: Array<string>;
  role?: Array<string>;
}
// const el = ()=>import("@/views/main/dashboard/DashboardHaloUt.vue");
import Vue from "vue";
import { mapActions, mapState } from "vuex";
import { getInitialsName } from "@/helpers";
const basePhotoUrl = process.env.VUE_APP_BASE_PHOTO_URL;
export default Vue.extend({
  data() {
    return {
      isLogoutDropdown: false,
      isSidebar: false,
      isLogoutModal: false,
      basePhotoUrl: basePhotoUrl,
      isPhotoError: false,
    };
  },
  components: {
    UtCustom: () => import("@/assets/static/logo/ut-custom.svg"),
    ModalPrimary: () => import("@/components/modal/ModalPrimary.vue"),
  },
  computed: {
    ...mapState("authService", ["userProfile"]),
    sidebars(): Array<SidebarMenu> {
      return [
        {
          to: { name: "Dashboard" },
          title: "Dashboard",
          icon: ["fa", "chart-line"],
          role: ["HALO UT", "ADMIN WR4", "FRONT DESK", "KEPALA UNIT", "WR4"],
        },
        {
          to: { name: "MainSurvey" },
          title: "Survey",
          icon: ["fa", "poll-h"],
          role: ["ADMIN WR4", "WR4"],
        },
        {
          to: { name: "Rating" },
          title: "Rating",
          icon: ["fa", "star"],
          role: ["ADMIN WR4", "KEPALA UNIT", "WR4"],
        },
        {
          to: { name: "Account" },
          title: "Account",
          icon: ["fa", "users"],
          role: ["ADMIN WR4"],
        },
        {
          to: { name: "Profile" },
          title: "Profile",
          icon: ["fa", "user"],
          role: ["ALL MAIN"],
        },
      ].filter(
        (sidebar) =>
          sidebar.role?.includes("ALL MAIN") ||
          sidebar.role?.includes(this.userProfile?.role?.name),
      );
    },
  },
  methods: {
    getInitialsName,
    ...mapActions("authService", ["postLogout"]),
  },
  watch: {
    userProfile() {
      this.isPhotoError = false;
    },
  },
});
